<script setup>
import { ref, reactive, watch, computed } from 'vue'

const props = defineProps({
    isOpen: Boolean,
    itemData: {
        type: Object,
        default: null
    }
})

const emit = defineEmits(['close', 'save'])

const initialForm = {
    id: null,
    name: '',
    role: 'User'
}

// 2. Khởi tạo formData
const formData = reactive({ ...initialForm })

const isEdit = computed(() => !!props.itemData && !!props.itemData.id)

// 3. Watch khi Sidebar MỞ hoặc ĐÓNG
watch(() => props.isOpen, (newVal) => {
    if (newVal) {
        if (props.itemData) {
            Object.assign(formData, props.itemData);
        } else {
            Object.assign(formData, initialForm);
        }
    }
}, { immediate: true });

const closeForm = () => {
    emit('close')
}

const handleSubmit = () => {
    emit('save', { ...formData })
}
</script>

<template>
    <div v-if="isOpen" class="form-sidebar-overlay" @click.self="closeForm">
        <div class="form-sidebar">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <h4>{{ isEdit ? 'Edit Item' : 'Add New' }}</h4>
                <button class="btn-close" @click="closeForm"></button>
            </div>

            <form @submit.prevent="handleSubmit">
                <div class="mb-3">
                    <label class="form-label">Name</label>
                    <input type="text" class="form-control" v-model="formData.name" required>
                </div>

                <div class="d-flex gap-2 mt-4">
                    <button type="button" class="btn btn-secondary w-100" @click="closeForm">Cancel</button>
                    <button type="submit" class="btn btn-primary w-100">
                        {{ isEdit ? 'Update' : 'Save' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<style scoped>
.form-sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    z-index: 9999 !important;
}
.form-sidebar {
    position: fixed;
    top: 0; right: 0;
    width: 400px; height: 100%;
    background: white;
    padding: 30px;
    box-shadow: -5px 0 15px rgba(0,0,0,0.1);
    animation: slideIn 0.3s ease-out;
}
@keyframes slideIn {
    from { transform: translateX(100%); }
    to { transform: translateX(0); }
}
</style>
